export const selectAllMessagesCommand = "C9d_Tc";
export default {selectAllMessagesCommand};